import { useEffect } from 'react';
import Icon from './Icon';
import ModalRoot from '../components/ModalRoot';

// Phone-sized sheet: drag handle, title row, a scrolling body and a
// footer that stays put — so the submit button is never below the fold
// with the keyboard up. On desktop the same markup renders as a centered
// dialog (see mobile.css). Closing is the caller's decision (onClose).
export default function BottomSheet({ open, title, subtitle, onClose, footer, children, closeDisabled }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = e => { if (e.key === 'Escape' && !closeDisabled) onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose, closeDisabled]);

  if (!open) return null;
  return (
    <ModalRoot className="m-sheet-overlay" onClick={() => !closeDisabled && onClose?.()}>
      <div className="m-sheet" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
        <div className="m-sheet-handle"><div /></div>
        <div className="m-sheet-head">
          <div style={{ minWidth: 0 }}>
            <h2 className="m-sheet-title">{title}</h2>
            {subtitle && <p className="m-sheet-sub">{subtitle}</p>}
          </div>
          <button type="button" className="m-sheet-close" onClick={onClose} disabled={closeDisabled} aria-label="Close">
            <Icon name="x" size={18} />
          </button>
        </div>
        <div className="m-sheet-body">{children}</div>
        {footer && <div className="m-sheet-foot">{footer}</div>}
      </div>
    </ModalRoot>
  );
}
